import router from '@/modules/auth/router'
import LoginApi from '@/modules/auth/service'
import { useUserStore } from '@/modules/auth/store'
export default {
  store: useUserStore,
  service: new LoginApi(),
  router,
}
